import { Outlet, Link } from "react-router-dom";
import { Nav, NavDropdown, Col, Row } from "react-bootstrap";
import Logo from '../../assets/images/sigma-logo-transparent.png'

const Layout = () => {
  return (
    <>
      <header className="header">
        <div className="container">
            <Nav className="me-auto">
            <Link to="/"><img src={Logo} alt="logo" /></Link>
            <Nav.Link href="/home">Home</Nav.Link>
            <Nav.Link href="/">Dashboard</Nav.Link>
          </Nav>
        </div>
      </header>

      <Outlet />
    </>
  )
};

export default Layout;